export const focusRestoreToLocalStorage = () => {
  const lastFocusedElementId = window.localStorage.getItem('lastFocusedElementId');
  if (lastFocusedElementId !== null) {
    const elementToFocus = document.getElementById(lastFocusedElementId);
    if (elementToFocus !== null) {
      return elementToFocus.focus();
    }
  }
};

export const setLastFocusedElementId = (id: string) => {
  return window.localStorage.setItem('lastFocusedElementId', id);
};
